import _ from 'lodash'

export const createBatchesMiddleOut = <A>(
  arr: A[],
  bottomIndex: number,
  topIndex: number,
  batchSize: number
): A[][] => {
  // pick at least 1 from each side. At the end after zipping, we chunk it again with the correct batchSize, so it will work for batchSize = 1 as well
  const bottomSize = Math.max(Math.floor(batchSize / 2), 1)
  const topSize = Math.max(batchSize - bottomSize, 1)

  const bottomArr = bottomIndex > 0 ? arr.slice(0, bottomIndex) : []

  const topArr =
    topIndex < arr.length - 1 ? arr.slice(topIndex + 1, arr.length) : []

  const bottomArrChunked = _.chunk(bottomArr.reverse(), bottomSize)
  const topArrChunked = _.chunk(topArr, topSize)

  const zippedChunks = _.zipWith(
    bottomArrChunked,
    topArrChunked,
    (a = [], b = []) => [...a, ...b]
  )

  // put the initial range at the beginning, so that it loads first
  zippedChunks.unshift(arr.slice(bottomIndex, topIndex + 1))

  // Now that we picked alternately from both sides of the initial item/range, join them all back, and chunk it again,
  // to ensure we get equal-sized batches of the requested size, regardless of the position in the list
  return _.chunk(zippedChunks.flat(), batchSize)
}
